<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
export let disabled = false
  function bubbleClick(e) {
    dispatch("click", e);
  }
</script>
<svg on:click="{bubbleClick}"
{disabled}
  class="bi bi-dash-circle icon icon-minus"
  width="1em"
  height="1em"
  viewBox="0 0 16 16"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    d="M8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 108 0a8 8 0 000 16z"
    clip-rule="evenodd" />
  <path
    fill-rule="evenodd"
    d="M3.5 8a.5.5 0 01.5-.5h8a.5.5 0 010 1H4a.5.5 0 01-.5-.5z"
    clip-rule="evenodd" />
</svg>
